export default "__VITE_ASSET__hmyufLXV__"